interface CheckoutShellProps {
  form: React.ReactNode;
  summary: React.ReactNode;
  mobileSummary: React.ReactNode;
}

export default function CheckoutShell({
  form,
  summary,
  mobileSummary,
}: CheckoutShellProps) {
  return (
    <div className="flex min-h-[100dvh] w-full">
      <section className="flex w-full flex-col px-5 py-8 md:w-[62%] md:px-12 md:py-10">
        {mobileSummary}
        {form}
      </section>
      {summary}
    </div>
  );
}
